<template>
  <div class="layout-list-container">
    <div class="layout-item" v-for="item in VIDEO_LAYOUT_LIST" :key="item.type"
      @click="selectLayout(item)"
    >
      <div :class="`layout-img ${curLayout.type === item.type ? 'active' : ''}`">
        <img :src="item.layoutImg" draggable="false"/>
        <div class="mask" v-show="liveDetail.status !== LIVE_STATUS.ING"></div>
      </div>
      <div class="layout-text">{{ item.typeText }}</div>
    </div>
  </div>
</template>

<script>
import { VIDEO_LAYOUT_LIST, LIVE_STATUS } from '@/consts/live'
export default {
  name: 'LayoutList', // 布局列表
  props: {
    previewLayout: {
      type: Object,
      default() {
        return {}
      }
    },
    liveDetail: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
  },
  watch: {
    'previewLayout.type': function (nVal) {
      this.curLayout = VIDEO_LAYOUT_LIST.find(i => i.type === nVal) || {}
    }
  },
  data () {
    return {
      LIVE_STATUS,
      VIDEO_LAYOUT_LIST,
      curLayout: {},
    }
  },
  methods: {
    selectLayout(layout) {
      if (this.liveDetail.status !== LIVE_STATUS.ING) return
      this.curLayout = layout
      this.$emit('selectLayout', layout)
      this.$emit('operationDOM')
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-list-container{
  display: flex;
  justify-content: space-around;
  padding: 0.2rem 1.0rem 0.6rem;
}
.layout-item{
  width: 18%;
  .layout-img{
    box-sizing: border-box;
    background-color:#EFF6FC;
    border-radius: .4rem;
    margin-bottom: .4rem;
    border: .4rem solid #fff;
    overflow: hidden;
    position: relative;
    &.active{
      border-color:#00CF96;
    }
    img{
      display: block;
      width: 100%;
      cursor: pointer;
    }
    .mask{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: .4rem;
      background-color: rgba(0,0,0,0.1);
      cursor: not-allowed;
      &::after{
        content: '';
        display: inline-block;
        width: 2.4rem;
        height: 2.4rem;
        background-image: url('~@/assets/img/guideStation/icon-nosignal@2x.png');
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
  }
  .layout-text{
    font-size: 1.4rem;
    color: #6E7785;
  }

}
</style>
